
/** 任务类 */
export namespace TaskKind {
    /** 任务状态 */
    export enum TaskState {
        /** 未开启状态 */
        NO_OPEN = 1,
        /** 进行中*/
        UNDERWAY, 
        /** 完成状态 未领取状态*/
        FINSH_NO_RECV, 
        /** 已领取状态 */
        RECV_SUCCESS, 
    }

    export enum TaskId {
        /** 完成第一关比武招亲 */
        TASK_1 = '1',
        /** 治疗丘比特 */
        TASK_2 = '2',
        /** 完成第二关比武招亲 */
        TASK_3 = '3',
        /** 合成神农鼎 */
        TASK_4 = '4',
        /** 解救华贵妃 */
        TASK_5 = '5',
        /** 完成夸贵妃 */
        TASK_6 = '6',
        /** 帮助丘比特找回翅膀 */
        TASK_7 = '8',
        /** 凑够彩礼 */
        TASK_8 = '7',
        /** 完成李白对诗 */
        TASK_9 = '9',
    }
    
}